import React, { useEffect } from 'react';
import { useDecision } from '@optimizely/react-sdk';
import AppRoutes from './AppRoutes';
import AppProvider from './utils/ContextProviders/AppContext';
import { initializeDDLogs, initializeDDRum } from './utils/datadog';
import { PAYMENT_FORM } from './utils/constants/checkout';

function App() {
  const [paymentFormFF] = useDecision(PAYMENT_FORM);

  useEffect(() => {
    const isCheckoutV2 = paymentFormFF.enabled && paymentFormFF.variationKey === 'on';
    initializeDDLogs(isCheckoutV2);
    initializeDDRum(isCheckoutV2);
  }, [paymentFormFF.enabled]);

  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}

export default App;
